import { useState, useEffect, useCallback } from "react";
import { getDependenciesForHook, getDebounceFn } from "utils/functions";
import useCancelToken from "./useCancelToken";

const cache = {};

export default function useFetchData({
	APIMethod,
	params = [],
	cache_name,
	debounce,
	condition = true,
	error_message,
	clear_data_on_update,
   extra_dependencies = [],
	resultDataHandler
}) {
	
	const [ getCancelToken, cancelQuery ] = useCancelToken();
	const [ data, setData ] = useState( null );
	const [ result, setResult ] = useState( null );
	const [ error, setError ] = useState( "" );
   const [ loading, setLoading ] = useState( false );

	const getData = async( params ) => {

		if ( !condition ) return;
		clear_data_on_update && setData( null );
      
      cancelQuery();
      setError( "" );
      setLoading( true );

      if ( cache_name ) cache[ cache_name ] = "loading";

		try {
			const data = await APIMethod( ...params, getCancelToken());
			if ( cache_name ) cache[ cache_name ] = data;

			setData( data );
         setTimeout(() => setLoading( false ), 60 );
		} catch ( e ) {
         if ( e?.code === "ERR_CANCELED" ) return;

			const error = error_message || e?.response?.data?.message || e?.response?.data?.error || "Błąd podczas pobierania danych!";	
			setError( error );
         setLoading( false );
		} 
	}

	const getDataDebounced = useCallback( getDebounceFn( getData, 500 ), [ condition ])

	const prepareResult = ( data ) => {
      const res = resultDataHandler ? resultDataHandler( data ) : data;
      setResult( res );
	}

	useEffect(() => {
      // Jeśli condition jest false, nie wywołuj getData
      if ( !condition ) {
         setData( null );
         setResult( null );
         return;
      }

      if ( cache_name && cache[ cache_name ] === "loading" ) {

         const check = () => setTimeout(() => {
            if ( cache[ cache_name ] === "loading" ) check();
            else setData( cache[ cache_name ])
         }, 500 );

         check();
         return;
      }

		if ( cache_name && cache[ cache_name ]) {
			setData( cache[ cache_name ]);
			return;
		}

		debounce ? getDataDebounced( params ) : getData( params )
	}, getDependenciesForHook([...params, ...extra_dependencies, condition ]));
	
	useEffect(() => {
		data ? prepareResult( data ) : setResult( null );
	}, [ data ])
	
	return {
		d: result,
		e: error,
      loading,
		update: () => getData( params ),
		set: ( r ) => setResult( r )
	};
}